'use client'

import dynamic from 'next/dynamic'

const Login = dynamic(() => import('@/modules/Auth/Login'), {
  ssr: false,
})

const Page: React.FC = () => {
  return <Login />
}

export default Page
